import styled from "styled-components";


export const AppWrapper = styled.div`
    margin: 0 auto;
    display: flex;
    justify-content: center;
    background-color: ${({theme}) => theme.colors. primaryAppBackground};
    overflow-y: scroll;
    position: relative;
`;

export const Main = styled.main`


`;